var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWbs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19463 4.40145L0.793213 8.80291V11.092V13.3811H3.09192H5.39062L9.79204 8.97967L14.1935 4.57822L11.9043 2.28911C10.6453 1.0301 9.61084 0 9.6056 0C9.60034 0 7.61541 1.98065 5.19463 4.40145ZM5.79678 5.50062L1.99751 9.29992V10.7479V12.1959H3.43587H4.87423L8.6832 8.38715L12.4922 4.57837L11.0537 3.13984C10.2626 2.34865 9.61095 1.70131 9.60568 1.70131C9.60038 1.70131 7.88637 3.411 5.79678 5.50062ZM0.831445 15.3978V16H8.01902H15.2066V15.3978V14.7957H8.01902H0.831445V15.3978Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWbs);
export default __webpack_public_path__ + "static/media/icon--wbs.744008f94e2748100205a3e674a600c6.svg";
export { ForwardRef as ReactComponent };